<template>
    <div class="showSite" >
        <el-collapse v-model="activeNames"  class="tabPanel">
            <el-collapse-item title="变配电" name="1"   >
                <div v-for="(item,index) in allArea" :key="index">
                    <div class="item" @click="href(item)"  v-if="item.areaId==26"><img :src="item.areaImg" alt="">{{item.areaName}}</div>
                </div>
            </el-collapse-item>
            <el-collapse-item title="微电网" name="2" >
                <div v-for="(item,index) in allArea" :key="index">
                    <div class="item" @click="href(item)" v-if="item.areaType!=1"><img :src="item.areaImg" alt="">{{item.areaName}}</div>
                </div>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
import {
    GET_AREAS,
} from "../../../api/power";
export default {
    data(){
        return {
            activeNames: ['1','2'],
            tabIdx:0,
            allArea:[]
        }
    },
    mounted(){
        this.AreaList();
    },
    methods:{
        AreaList(){
            GET_AREAS().then(res => {
                this.allArea = res.data.data.areas
            })
        },
        changeTab(idx){
            this.tabIdx = idx
        },
        href(item){
            this.$emit('AreaItem',item)
            console.log(item);

            this.$store.commit("webId", item.areaId);
            this.$store.commit("Dthere", 2);
            if(item.areaType == 1){
                this.$router.push({
                    path:`/SubstationManagement`,
                    name:'SubstationManagement',
                    query:{
                        name:"PowerDistribution",
                        id:item.areaId
                    },
                })
            }else if(item.areaType == 2){
                this.$router.push({
                    path:'/SubstationManagement',
                    name:'SubstationManagement',
                    query:{name:"PowerProfile",id:item.areaId}
                })
            }else if(item.areaType == 3){
                this.$router.push({
                    path:'/SubstationManagement',
                    name:'SubstationManagement',
                    query:{name:"PtorageSituation",id:item.areaId}
                })
            }
            this.$emit('closedArea',false)
        }
    }
}
</script>

<style lang='less' scoped>
    /deep/.tabPanel{
        border: 0;

        .item{
            padding:8rem 10rem;
            cursor: pointer;
            img{
                width: 24rem;
                height: 24rem;
                vertical-align: middle;
                margin-right: 8px;
            }
            font-size: 18rem;
            color: #666;
        }
        .el-collapse-item__content{
            padding: 0;
            padding-left: 25px;
        }
        .el-collapse-item__header,.el-collapse-item__wrap{
            border: 0;
        }
        .el-collapse-item__arrow{
            position: absolute;
            left: 12px;
            top: 31%;
        }
        .el-collapse-item__header{
            position: relative;
            padding-left: 33px;
            font-size: 18rem;
            font-weight: bold;
            height: 40rem;
            line-height: 40rem;
        }
    }
    .showSite{
        position: absolute;
        top: 100%;
        left: 0;
        width: 320rem;
        height: 264rem;
        z-index: 111;
        padding-top: 10px;
        background-color: #fff;
        box-shadow: 0px 4px 40px 0px rgba(0, 43, 102, 0.28);
        .tabIn{
            width: 100%;
            height: 52rem;
            span{
                display: inline-block;
                padding:13rem 0 10rem 0;
                width: 33.3333333%;
                color: #333;
                font-weight: bold;
                text-align: center;
                font-size: 18rem;
                border-bottom: 3rem solid rgba(0, 0, 0, 0.15);
                vertical-align: middle;
                cursor: pointer;
            }
            .tabInd{
                border-bottom: 3rem solid #0D94FF;
                color: #0D94FF;
            }
        }
        .concentArea{
            width: 100%;
            height: calc(100% - 43rem);
            // padding: 1rem 8rem 0 23rem;
            .areaScorll{
                width: 100%;
                height: 96%;
                overflow: scroll;
                .tabBox{
                    padding: 12rem 8rem  12rem 23rem;
                    cursor: pointer;
                    img{
                        width: 40rem;
                        height: 40rem;
                        vertical-align: middle;
                        margin-right: 23rem;
                    }
                    color:#666 ;
                    font-size: 18rem;
                    font-weight: 400;
                    &:hover{
                        background-color: #f4f4f4;
                        color: #0D94FF;
                    }
                }
                
            }
            ::-webkit-scrollbar{
                width: 5rem;
                height: 8rem;
            }
            ::-webkit-scrollbar-thumb{
                background-color: #fff;
                border-radius: 3rem;
                border: 1rem solid #ccc;
            }
        }
    }
</style>